import { TableHead, TableRow } from "@vega-core/components/shadcn/table";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

import { type GroupedHeader } from "../types";

type Props = {
  groupedHeaders: GroupedHeader[];
};

export const TableGroupHeader = ({ groupedHeaders }: Props) => (
  <TableRow>
    <TableHead className="invisible" />

    {groupedHeaders.map(({ label, colSpan }, index) => (
      <TableHead
        className={cnTwMerge(
          "bg-background/secondary text-text/primary px-3 py-2 base-body-semibold text-center",
          index === 0 &&
            "rounded-tl-companyBorderRadius border-border/primary border-t border-l border-r-[1.5rem]",
          index === groupedHeaders.length - 1 &&
            "border-border/primary border-t border-r rounded-tr-companyBorderRadius",
          index !== groupedHeaders.length - 1 ? "border-r-[1.5rem]" : "",
        )}
        colSpan={colSpan}
        key={label}
      >
        {label}
      </TableHead>
    ))}
  </TableRow>
);
